define(
    'C3.ShoppingExtensions.SignUp.Model',
    [
        'SCModel',
        'Utils'
    ],
    function(SCModelComponent, Utils){
        'use strict';

        var SCModel = SCModelComponent.SCModel;

        function SignUpModel() {
            SCModel.call(this);

            // Define properties of the model.
            this.urlRoot = function() {
                return Utils.getAbsoluteUrl(
                    getExtensionAssetsPath("services/SignUp.Service.ss")
                )
            }

            this.validation = function() {
                return {
                    firstname: {
                        required: true,
                        msg: Utils.translate('First Name is Required')
                    },
                    lastname: {
                        required: true,
                        msg: Utils.translate('Last Name is Required')
                    },
                    email: [
                        {
                            required: true,
                            msg: 'Email Address is Required'
                        },
                        {
                            pattern: 'email',
                            msg: 'Valid email address is required'
                        }
                    ],
                    custentity13: {
                        required: true,
                        msg: Utils.translate('Territory is Required')
                    }
                }
            }
        }

        SignUpModel.prototype = Object.create(SCModel.prototype);

        SignUpModel.prototype.constructor = SignUpModel;

        // Return the AMD constructor.
        return SignUpModel;
    }
);
